
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { OrderDocumentsService, Tag } from 'app/shared/services/order-documents/order-documents.service';
import { DocumentDialogData } from '../../order-documents.component';
import { AutocompleteTag } from 'app/shared/components/tags-autocomplete/tags-autocomplete/tags-autocomplete.component';
import { atLeastOneTagValidator } from 'app/shared/helpers/form.helpers';
import moment from 'moment';

@Component({
    selector: 'app-dialog-edit-document',
    templateUrl: './dialog-edit-document.component.html',
    styleUrls: ['../../dialog-upload-document/dialog-upload-document.component.scss'],
    standalone: false
})

export class DialogEditDocumentComponent implements OnInit {
  ediDocumentForm: UntypedFormGroup;
  allAvailableTags: Tag[] = [];
  defaultTags: AutocompleteTag[] = [];
  loading: boolean = false;
  tagsCtrl: UntypedFormControl = new UntypedFormControl([]);
  constructor(private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private documentService: OrderDocumentsService,
    @Inject(MAT_DIALOG_DATA) public data: DocumentDialogData,
    private dialogRef: MatDialogRef<DialogEditDocumentComponent>,
  ) { }

  ngOnInit(): void {
    this.ediDocumentForm = this.formBuilder.group({
      document_name: [this.data.document.title, Validators.required],
      tags: [''],
      custom_tags: [[]],
      expiry_date: [this.data.document.expiryDate ? this.data.document.expiryDate : null]
    }, { validator: atLeastOneTagValidator() });
    this.allAvailableTags = this.data.tags;
    this.defaultTags = this.data.document.tags.map(tag => ({ id: tag.tag_id, name: tag.name }));

    if (this.data.options?.disableDocumentTitleInEditDialog) {
      this.ediDocumentForm.get('document_name').disable();
    } else {
      this.ediDocumentForm.get('document_name').enable();
    }

    if (this.data.options?.disableTagAutocompleteInEditDialog) {
      this.data.options.tagsAutocompleteOptions = { ...this.data.options.tagsAutocompleteOptions, disabled: true }
    }
  }

  onSelectedTagsChanged(selectedTags: AutocompleteTag[]): void {
    const tags = selectedTags.filter(tag => !tag?.custom).map(tag => tag.id).join(',');
    const custom_tags = selectedTags.filter(tag => tag?.custom).map(tag => ({ name: tag.name }));
    this.ediDocumentForm.patchValue({ tags, custom_tags })
  }


  saveDocument() {
    if (this.ediDocumentForm.valid) {
      this.loading = true;
      const data = {
        ...this.ediDocumentForm.getRawValue(),
        user_id: this.data.userId,
        document_id: this.data.document.document_id,
      }
      if (this.data.orderId) {
        data.order_id = this.data.orderId;
      }

      if (data.expiry_date) {
        data.expiry_date = moment(data.expiry_date).format('DD/MM/YYYY');
      }

      this.documentService.updateDocument(data).subscribe(
        () => {
          this.loading = false;
          this.dialogRef.close(true);
          this.alertService.notifySuccess('Document saved successfully');
        },
        () => {
          this.loading = false;
          this.alertService.notifyError('Failed to save document. Please try again later.');
        }
      );
    } else {
      this.ediDocumentForm.markAllAsTouched();
    }
  }

  isFieldHasRequiredError(fieldName: string): boolean {
    const control = this.ediDocumentForm.get(fieldName);
    return control?.errors?.required && control?.touched;
  }

}
